import { z } from 'zod';

export const ZipRepositoryFileNameSchema = z
  .string()
  .regex(
    /^[a-zA-Z0-9._-]+\.zip$/i,
    'ZIP file name may only contain letters, numbers, dots, underscores, and hyphens',
  );
